/**
 * Build a safe Sitecore media URL from an <image /> field value.
 * Recommended for video thumbnails in Headless / XM Cloud.
 */
export const buildSitecoreMediaUrl = (
  imageFieldValue?: string,
  options?: {
    host?: string;
    width?: number;
    height?: number;
  }
): string => {
  if (!imageFieldValue) return '';
  const { host, width, height } = options || {};
  // Decode HTML entities
  const decoded = imageFieldValue
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
  // Extract mediaid
  const match = decoded.match(/mediaid="\{([^}]+)\}"/i);
  if (!match?.[1]) return '';

  // Remove hyphens from GUID
  const mediaId = match[1].replace(/-/g, '');
  // Build base URL
  const baseUrl = host ? `https://${host}` : '';
  // Build query params
  const params = new URLSearchParams();
  if (width) params.append('mw', width.toString());
  if (height) params.append('mh', height.toString());
  const query = params.toString();
  return `${baseUrl}/-/media/${mediaId}.ashx${query ? `?${query}` : ''}`;
};

export const getExternalLinkUrl = (rawValue?: string): string => {
  if (!rawValue) return '';

  try {
    // Decode HTML entities
    const decoded = rawValue.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    // Extract url
    const match = decoded.match(/url="([^"]+)"/i);
    return match?.[1] || '';
  } catch (e) {
    console.error('Failed to parse external link field', e);
    return '';
  }
};

export const parseImageSize = (value?: string) => {
  if (!value) return {};
  const img = new DOMParser().parseFromString(value, 'text/xml').querySelector('image');

  return {
    width: img?.getAttribute('width') || undefined,
    height: img?.getAttribute('height') || undefined,
    alt: img?.getAttribute('alt') || '',
  };
};
